<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="物流代码" name="logistics_code"></c-form-item>
                    <c-form-item type="input" label="物流名称" name="logistics_name"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_standard_logistics_edit" color="sys" @click="createLogisticsCompany">新增发货物流
                </c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="物流代码"
                        name="logistics_code"
                        width="110"
                >
                </c-table-column>

                <c-table-column
                        label="物流名称"
                        name="logistics_name"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        label="LOGO"
                        name="logistics_logo"
                        width="140"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image v-if="data.logistics_logo" :src="data.logistics_logo" preview size="30"
                                     style="margin-right: 10px;"></c-image>
                            <span v-else>--</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:red">禁用</span>
                        <span v-if="data.state == 2" style="color:green">启用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        power="b_standard_logistics_edit"
                        @sort="sortHandle"
                >
                </c-table-column>

                <c-table-column
                        label="创建日期"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_standard_logistics_edit" v-if="data.id > 0" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_standard_logistics_edit" v-if="data.state == 1" @click="updateState(2, data)">{{ '启用' }}</c-table-button>
                        <c-table-button power="b_standard_logistics_edit" v-if="data.state == 2" @click="updateState(1, data)">{{ '禁用' }}</c-table-button>
                        <c-table-button power="b_standard_logistics_edit" v-if="data.id > 0 && data.state == 1" @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="logisticsCompanyEdit" :title="editState ? '编辑发货物流' : '新增发货物流'" width="600"
                  @resolve="submitLogisticsCompany">
            <c-form ref="logisticsCompanyForm">
                <c-form-item type="input" label="物流代码" name="logistics_code" required>
                    <span slot="word">该物流代码将用作查询物流轨迹使用，如不确定物流公司代码，请
                        <a class="s-link" target="_blank"
                           href="https://market.aliyun.com/detail/cmapi021863#sku=yuncode15863000017">点击查看</a>
                        标准物流公司代码、名称
                    </span>
                </c-form-item>
                <c-form-item type="input" label="物流名称" name="logistics_name" required></c-form-item>
                <c-form-item type="image" label="物流LOGO" name="logistics_logo"
                             file-word="建议上传物流公司的LOGO图片；"></c-form-item>
                <c-form-item type="radio" label="是否启用" name="state" :options="stateType" required></c-form-item>
                <c-form-item type="hidden" name="id"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
export default {
    name: 'm_standard_logistics',

    data() {
        return {
            isCollect: [{
                name: '不支持',
                value: 0
            }, {
                name: '支持',
                value: 1
            }],

            stateType: [{
                name: '禁用',
                value: 1
            }, {
                name: '启用',
                value: 2
            }],

            editState: false
        }
    },

    mounted() {
        this.$refs.search.search();
    },

    methods: {
        searchHandle(data) {
            this.$refs.table.load({
                url: '/standard_logistics/list',
                data
            });
        },

        sortHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData = {};
            if (type == 'top' || type == 'bottom') {
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if (type == 'up') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if (type == 'down') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/standard_logistics/sort',
                data: submitData,
                loading: true,
                success: data => {
                    if (type == 'top' || type == 'bottom') {
                        this.$refs.table.update();
                    } else {
                        next();
                    }
                }
            });
        },

        createLogisticsCompany() {
            this.editState = false;
            this.$refs.logisticsCompanyForm.clear();
            this.$refs.logisticsCompanyForm.set({});
            this.$refs.logisticsCompanyEdit.open();
        },

        edit(val) {
            this.editState = true;
            this.$refs.logisticsCompanyForm.set(val);
            this.$refs.logisticsCompanyEdit.open();
        },

        del(val) {
            this.$confirm({
                text: '删除发货物流后，可能导致物流轨迹查询失败，是否确认删除【' + val.logistics_name + '】？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/standard_logistics/remove',
                        data: {logistics_id: val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        updateState(type, val) {
            var msg = "";
            if (type == 1) {
                msg = '确定要启用【' + val.logistics_name + '】吗？';
            } else {
                msg = '禁用后发货时将无法选择该物流，是否确认禁用【' + val.logistics_name + '】？';
            }
            this.$confirm({
                text: msg,  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/standard_logistics/edit_state',
                        data: {logistics_id: val.id, state: type},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        submitLogisticsCompany(stop) {
            stop();
            let submitUrl = '/standard_logistics/add';
            if (this.editState) {
                submitUrl = '/standard_logistics/edit';
            }
            this.$refs.logisticsCompanyForm.submit({
                url: submitUrl,
                rule: {
                    logistics_code: [{
                        type: 'empty',
                        word: '请填写物流代码'
                    }],

                    logistics_name: [{
                        type: 'empty',
                        word: '请填写物流名称'
                    }],

                    state: [{
                        type: 'empty',
                        word: '请选择是否启用'
                    }]
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    this.$message({
                        text: '操作成功',
                        icon: 'success'
                    });
                    this.$refs.table.update();
                    this.$refs.logisticsCompanyEdit.close();
                },
            });
        }
    }
}
</script>